<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option mgb_5">
				<span class="mgr_5">
					<em class="lt_text">Search Period</em>
				</span>
				<span class="int_type_no_border">
					<select class="tbl_select" v-model="year_from">
						<option v-for="i in this_year + 1 - 2000" :key="i" :value="this_year - (i - 1)">{{ this_year - (i - 1) }}</option>
					</select>
				</span>

				<em class="lt_text"> ~ </em>

				<span class="int_type_no_border mgr_10">
					<select class="tbl_select" v-model="year_to" :disabled="!year_from">
						<option v-for="i in this_year - year_from + 1" :key="i" :value="this_year - (i - 1)">{{ this_year - (i - 1) }}</option>
					</select>
				</span>

				<span class="int_type_no_border mgr_10">
					<ItemSelectMulti v-model.trim="selected_items_str" :active_only="false" :separator="separator" :resultsDisplay="obj => obj.item_code + ' | ' + obj.name" />
				</span>

				<a href="javascript:;" class="search_bt" @click="search()">Search</a>
				<a href="javascript:;" class="gray_bt" @click="reset()">Reset</a>
			</div>

			<div class="left_option mgb_5">
				<em class="lt_text">Item {{ headers.class }}</em>

				<span class="int_type quarter3_int">
					<AC ref="ac" :source="selectClasses" @selected="selectClass" results-display="code_name" placeholder="Item / Class Name or Code"> </AC>
				</span>

				<span class="int_type_no_border mgr_15">
					<ItemClassSelectMulti v-model.trim="item_classes_string" :selectOnClick="false" @keydown="search" />
				</span>

				<em class="lt_text">Item Color</em>
				<span class="int_type">
					<input type="text" v-model.trim="colors_string" placeholder="ex) 1, 2, 1B" autocomplete="off" @keyup.enter="search()" @focus="$event.target.select()" />
				</span>
				<span>(Only Applied In Case Of Searching by {{ headers.class }}.)</span>
			</div>
		</div>

		<div style="width: 100%; overflow-x: auto;">
			<table class="list_tbl" :style="{ width: 25 * year_list.length + '%' }">
				<colgroup>
					<template v-for="i in year_list.length">
						<col :style="{ width: '120px' }" :key="i + 'col0'" />
						<col :style="{ width: 'calc((25% - 120px) / 2)' }" :key="i + 'col1'" />
						<col :style="{ width: 'calc((25% - 120px) / 2)' }" :key="i + 'col2'" />
					</template>
				</colgroup>
				<tbody>
					<tr>
						<template v-for="(year, index) in year_list">
							<th :key="year + 'criteria'">
								<template v-if="index === 0">
									<select class="tbl_select" v-model="amt_qty">
										<option value="amt">Amount</option>
										<option value="qty">Quantity</option>
									</select>
								</template>
							</th>
							<th class="al_center big_red" :key="year">{{ year }}</th>

							<th class="border_right" :key="year + 'blank'"></th>
						</template>
					</tr>
					<tr>
						<template v-for="year in year_list">
							<th :key="year + 'blank2'"></th>
							<th class="al_center" :key="year + 'th'">Sales</th>
							<th class="al_center border_right" :key="year + 'td'">Purchase</th>
						</template>
					</tr>
					<tr v-for="(display, i) in display_list" :key="i">
						<template v-for="(year, j) in year_list">
							<template v-if="display[j]">
								<td class="al_center" :key="i + '/' + year + '0'">{{ display[j].month_str }}</td>
								<template v-if="amt_qty === 'amt'">
									<td class="al_right" :key="i + '/' + year + '1'">{{ display[j].sales_amount | toCurrency }}</td>
									<td class="al_right" :key="i + '/' + year + '2'">{{ display[j].rcvd_amount | toCurrency }}</td>
								</template>
								<template v-if="amt_qty === 'qty'">
									<td class="al_right" :key="i + '/' + year + '1'">{{ display[j].sales_quantity | commaSeparated }}</td>
									<td class="al_right" :key="i + '/' + year + '2'">{{ display[j].rcvd_quantity | commaSeparated }}</td>
								</template>
							</template>
						</template>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="view_bottom_bt">
			<a href="javascript:void(0);" type="button" class="search_bt" @click="exportExcel">Excel</a>
		</div>
	</div>
</template>

<script>
import ItemClassSelectMulti from '@/components/common/ItemClassSelectMulti';
import ItemSelectMulti from '@/components/common/ItemSelectMulti';
import AC from '@/components/common/AC';

import { apiAnnualHistoryByGoods } from '@/api/report/report.js';
import { exportDataExcel } from '@/api/util';
import { defaultDataType } from 'export-xlsx';

export default {
	data: () => ({
		year_from: 0,
		year_to: 0,

		item_classes_string: null,
		colors_string: null,
		selected_items_str: null,
		separator: ',',

		amt_qty: 'amt',
		display_list: [],

		saveParam: {},
	}),
	components: {
		AC,
		ItemClassSelectMulti,
		ItemSelectMulti,
	},
	props: {
		headers: Object,
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
		item_classes() {
			return this.item_classes_string ? this.item_classes_string.split(this.separator) : [];
		},
		colors() {
			return this.colors_string ? this.colors_string.split(this.separator) : [];
		},
		selected_item_codes() {
			return this.selected_items_str ? this.selected_items_str.split(this.separator) : [];
		},
		year_list() {
			const year_list = [];
			if (this.saveParam && this.saveParam.year_from && this.saveParam.year_to) {
				for (let i = this.saveParam.year_from; i <= this.saveParam.year_to; i++) {
					year_list.push(i);
				}
			}

			return year_list;
		},
	},
	methods: {
		selectClasses(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_class/acClassList?company_id=' + this.user.company_id + '&include_closed_yn=Y&keyword=' + input;
			return url;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.item_classes_string) this.item_classes_string += this.separator + c.selectedObject.code;
			else this.item_classes_string = c.selectedObject.code;
		},
		async exportExcel() {
			if (!this.display_list || !this.display_list.length) {
				this.$toast.error('No Data to Export.');
				return false;
			}

			const hearderGroups = [];
			const headers = [];
			for (const year of this.year_list) {
				hearderGroups.push({ key: year + '_headerGroup', name: String(year) });

				headers.push({ key: year + '_month', name: '', groupKey: year + '_headerGroup', width: 20, dataType: defaultDataType.string });
				headers.push({ key: year + '_sales', name: 'Sales', groupKey: year + '_headerGroup', width: 20, dataType: this.amt_qty === 'amt' ? defaultDataType.number : defaultDataType.currency });
				headers.push({ key: year + '_purchase', name: 'Purchase', groupKey: year + '_headerGroup', width: 20, dataType: this.amt_qty === 'amt' ? defaultDataType.number : defaultDataType.currency });
			}

			const excel_data = [];
			for (const per_month of this.display_list) {
				let obj = {};
				for (const per_year of per_month) {
					obj[per_year.year + '_month'] = per_year.month_str;
					if (this.amt_qty === 'amt') {
						obj[per_year.year + '_sales'] = per_year.sales_amount;
						obj[per_year.year + '_purchase'] = per_year.rcvd_amount;
					} else {
						obj[per_year.year + '_sales'] = per_year.sales_quantity;
						obj[per_year.year + '_purchase'] = per_year.rcvd_quantity;
					}
				}
				excel_data.push(obj);
			}

			exportDataExcel(excel_data, headers, 'purchaseHistoryByGoods', hearderGroups);
		},
		convertData(data) {
			if (!Array.isArray(data)) return [];

			const month_str_list = ['01.Jan', '02.Feb', '03.Mar', '04.Apr', '05.May', '06.Jun', '07.Jul', '08.Aug', '09.Sep', '10.Oct', '11.Nov', '12.Dec'];
			const display_list = [];
			for (let i = 0; i < 12; i++) {
				const month_list = data.filter(el => el.month === i + 1);
				display_list.push([]);

				for (let j = 0; j < this.year_list.length; j++) {
					let idx = month_list.findIndex(m => m.year === this.year_list[j]);

					if (idx > -1) display_list[i].push({ month_str: month_str_list[i], ...month_list[idx] });
					else display_list[i].push({ month_str: month_str_list[i], year: this.year_list[j], month: i + 1, sales_quantity: 0, sales_amount: 0, rcvd_quantity: 0, rcvd_amount: 0 });
				}
			}

			const totals = [];
			for (const year of this.year_list) {
				const year_data = data.filter(el => el.year === year);
				totals.push({
					month_str: 'Total',
					year: year,
					sales_quantity: year_data.reduce((prev, curr) => prev + curr.sales_quantity, 0),
					sales_amount: year_data.reduce((prev, curr) => prev + curr.sales_amount, 0),
					rcvd_quantity: year_data.reduce((prev, curr) => prev + curr.rcvd_quantity, 0),
					rcvd_amount: year_data.reduce((prev, curr) => prev + curr.rcvd_amount, 0),
				});
			}

			display_list.push(totals);

			return display_list;
		},
		async search() {
			if (!this.year_from || !this.year_to) {
				this.$toast.error('Please Select Search Period');
				return;
			}

			this.saveParam = {
				year_from: this.year_from,
				year_to: this.year_to,

				item_classes: this.item_classes,
				color_codes: this.colors,
				item_codes: this.selected_item_codes,
			};

			let { data } = await apiAnnualHistoryByGoods(this.saveParam);
			this.display_list = this.convertData(data);
		},
		reset() {
			this.this_year = new Date().getFullYear();
			this.year_to = this.this_year;
			this.year_from = this.year_to - 2;

			this.item_classes_string = '';
			this.colors_string = '';
			this.selected_items_str = '';
		},
	},
	created() {
		this.reset();

		this.$store.commit('setSideIndex', 7);
		this.$store.commit('setSelectedMenu', 'nav_li_annual_history_by_goods');
		this.$store.commit('setSubTitle', 'Report -> Annual History by Goods');
	},
};
</script>

<style scoped>
.big_red {
	color: red;
	font-size: 15px;
}
.border_right {
	border-right: 1px solid #dbdbdb;
}
</style>
